document.querySelectorAll('.preorder-trigger').forEach(trigger => {

  const modalId = trigger.dataset.preorderOpen;
  const modal = document.getElementById(modalId);

  if (!modal) return;

  let openTimer;
  let closeTimer;

  /* OPEN WITH DELAY */

  trigger.addEventListener('mouseenter', () => {

    clearTimeout(closeTimer);

    openTimer = setTimeout(() => {
      modal.classList.add('active');
    }, 300); // delay before opening (ms)

  });

  /* CANCEL IF USER LEAVES EARLY */

  trigger.addEventListener('mouseleave', () => {
    clearTimeout(openTimer);

    closeTimer = setTimeout(() => {
      modal.classList.remove('active');
    }, 200);
  });

  /* KEEP OPEN IF HOVERING MODAL */

  modal.addEventListener('mouseenter', () => {
    clearTimeout(closeTimer);
  });

  modal.addEventListener('mouseleave', () => {
    modal.classList.remove('active');
  });

});

document.querySelectorAll('.preorder-close').forEach(button => {
  button.addEventListener('click', function () {
    const modal = this.closest('.preorder-modal');
    if (modal) {
      modal.classList.remove('active');
    }
  });
});